import React from 'react';

/**
 * Renders an emoji flag as a Twemoji SVG image.
 * Windows doesn't render emoji flags natively — this ensures they display on all platforms.
 *
 * Usage: <FlagEmoji emoji="🇫🇷" /> or <FlagEmoji emoji="🇫🇷" size={24} />
 */
const emojiToTwemojiUrl = (emoji) => {
  const codePoints = [...emoji]
    .map((char) => char.codePointAt(0).toString(16))
    .join('-');
  return `https://cdn.jsdelivr.net/gh/twitter/twemoji@latest/assets/svg/${codePoints}.svg`;
};

const FlagEmoji = ({ emoji, size = 20, style = {} }) => {
  return (
    <img
      src={emojiToTwemojiUrl(emoji)}
      alt={emoji}
      style={{
        width: size,
        height: size,
        verticalAlign: 'middle',
        ...style,
      }}
      draggable={false}
    />
  );
};

export default FlagEmoji;
